import { render, staticRenderFns } from "./TaskCalendarView.vue?vue&type=template&id=bab9ef3a&scoped=true"
import script from "./TaskCalendarView.vue?vue&type=script&lang=js"
export * from "./TaskCalendarView.vue?vue&type=script&lang=js"
import style0 from "./TaskCalendarView.vue?vue&type=style&index=0&id=bab9ef3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab9ef3a",
  null
  
)

export default component.exports